import React from 'react';
import Style from './App.module.css';
import DefaultLayout from './DefaultLayout/DefaultLayout';

export default function App() {
	return <DefaultLayout />;
}
